import { fetchApi } from 'src/_helpers/client/fetchApi'

export const PATH = '/api/open/cookie_ips'

async function accept(content, onSuccess) {
  return await fetchApi(
    PATH,
    'POST',
    { 'Content-Type': 'application/json', accept: 'application/json' },
    { body: JSON.stringify({ content }), credentials: 'same-origin' },
  ).then(
    (response) => {
      onSuccess(response)
    },
    (error) => {
      if (error.status === 404) {
        return null
      }

      console.log(error)

      throw new Error(`Failed to accept cookies: ${PATH}`)
    },
  )
}

export const cookieIpService = {
  accept,
}
